import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getFuncionesPorIdEspectaculo } from 'services/servicioGet';
import { Funcion } from 'utils/models/types';

interface FuncionesState {
  funciones: Funcion[];
  loadingFunciones: boolean;
  errorFunciones: string | null;
}

// Estado inicial del slice
const initialState: FuncionesState = {
  funciones: [],
  loadingFunciones: false,
  errorFunciones: null,
};

// Thunk para obtener las funciones
export const fetchFuncionesEspectaculo = createAsyncThunk<Funcion[], number, { rejectValue: string }>(
  'espectaculos/fetchFuncionesEspectaculo',
  async (id, { rejectWithValue }) => {
    try {
      const response = await getFuncionesPorIdEspectaculo(id.toString());
      return response;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de funciones
const funcionesPorIdEspectaculoSlice = createSlice({
  name: 'funciones',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchFuncionesEspectaculo.pending, state => {
        state.loadingFunciones = true;
        state.errorFunciones = null;
      })
      .addCase(fetchFuncionesEspectaculo.fulfilled, (state, action) => {
        state.funciones = action.payload;
        state.loadingFunciones = false;
      })
      .addCase(fetchFuncionesEspectaculo.rejected, (state, action) => {
        state.loadingFunciones = false;
        state.errorFunciones = action.payload as string;
      });
  },
});

export default funcionesPorIdEspectaculoSlice.reducer;
